import React from "react";
import { PomLastTestResponse, PomTestData } from "../../typings/pom";
import Button from "../UI/Button";
import { Card, CardContent, CardHeader } from "../UI/Card";
import { Eye, Info } from "lucide-react";
import PomPdfDownload from "./PomPdfDownload";

interface PomLastTestProps {
  lastTest: PomLastTestResponse;
  onViewDetail: () => void;
}

const PomLastTest: React.FC<PomLastTestProps> = ({
  lastTest,
  onViewDetail,
}) => {
  const test = lastTest.data.test;

  const typeInterpretations: Record<string, string> = {
    ISTJ: 'Teliti, terstruktur, bertanggung jawab',
    ISFJ: 'Peduli, stabil, loyal',
    INFJ: 'Visioner, empatik, idealis',
    INTJ: 'Strategis, analitis, mandiri',
    ISTP: 'Praktis, logis, problem-solver',
    ISFP: 'Fleksibel, artistik, tenang',
    INFP: 'Reflektif, kreatif, penuh nilai',
    INTP: 'Analitis, konseptual, penasaran',
    ESTP: 'Aksi cepat, adaptif, energik',
    ESFP: 'Spontan, ceria, sosial',
    ENFP: 'Inspiratif, kreatif, energik',
    ENTP: 'Debater, inovatif, strategis',
    ESTJ: 'Eksekutor, efisien, terorganisir',
    ESFJ: 'Supportif, komunikatif, kooperatif',
    ENFJ: 'Pemimpin empatik, inspiratif',
    ENTJ: 'Visioner, tegas, pemimpin alami',
  };

  const mbtiType = `${test.ei_result}${test.sn_result}${test.tf_result}${test.jp_result}`;

  const dimensions = [
    { label: "Energi", left: "Extraversion", leftVal: test.e, right: "Introversion", rightVal: test.i, result: test.ei_result },
    { label: "Informasi", left: "Sensing", leftVal: test.s, right: "Intuition", rightVal: test.n, result: test.sn_result },
    { label: "Keputusan", left: "Thinking", leftVal: test.t, right: "Feeling", rightVal: test.f, result: test.tf_result },
    { label: "Struktur", left: "Judging", leftVal: test.j, right: "Perceiving", rightVal: test.p, result: test.jp_result },
  ];

  return (
    <Card className="mt-6 border-indigo-100 shadow-md">
      <CardHeader className="border-b border-indigo-50 bg-indigo-50/30">
        <div className="flex justify-between items-center">
          <h5 className="text-lg font-bold text-indigo-900">Hasil Terakhir</h5>
          <span className="text-xs text-indigo-600 bg-indigo-100 px-2 py-1 rounded-full font-medium">
            {new Date(test.created_at).toLocaleDateString("id-ID", {
              day: 'numeric',
              month: 'long',
              year: 'numeric'
            })}
          </span>
        </div>
      </CardHeader>
      <CardContent className="p-6">
        <div className="flex flex-col items-center mb-8">
          <div className="text-xl font-bold text-primary text-center mb-1">
            {typeInterpretations[mbtiType] || ''}
          </div>
          <div className="text-xs text-gray-500 font-medium italic uppercase tracking-wider">Tipe Karakter Anda</div>
        </div>

        <div className="flex flex-col gap-3">
          <Button
            primary
            className="w-full gradient-primary py-4 font-bold flex items-center justify-center gap-2"
            onClick={onViewDetail}
          >
            <Eye className="w-5 h-5" /> Lihat Analisis Lengkap
          </Button>
          <PomPdfDownload testId={test.id} />
        </div>
      </CardContent>
    </Card>
  );
};

export default PomLastTest;
